import LegalPageLayout from "./LegalPageLayout";

const SECTIONS = [
  {
    heading: "1. Acceptance of Terms",
    blocks: [
      {
        type: "p",
        text: "These Terms & Conditions (\"Terms\") govern your access to and use of the MagicBolt AI platform and website, operated by MagicBolt Private Limited (\"MagicBolt AI\", \"we\", \"us\"). By creating an account or using our services, you agree to be bound by these Terms. If you do not agree, do not use the platform.",
      },
    ],
  },
  {
    heading: "2. Description of Service",
    blocks: [
      {
        type: "p",
        text: "MagicBolt AI provides automation for Google Business Profile, Facebook, Instagram, WordPress, SEO/AEO/GEO and related marketing workflows, including white-label and reseller tools for digital agencies. Features may be added, changed or removed at our discretion.",
      },
    ],
  },
  {
    heading: "3. Account Registration",
    blocks: [
      {
        type: "p",
        text: "You must provide accurate, current information when creating an account and are responsible for maintaining the confidentiality of your login credentials and for all activity under your account.",
      },
    ],
  },
  {
    heading: "4. Subscription Plans & Billing",
    blocks: [
      {
        type: "ul",
        items: [
          "Plans are billed monthly or yearly as selected at checkout; yearly billing is offered at a discounted rate.",
          "Fees are charged in advance and are exclusive of applicable taxes unless stated otherwise.",
          "You may upgrade, downgrade or add channels at any time; changes are reflected in your next billing cycle unless otherwise stated.",
          "Failure to pay may result in suspension or termination of access to the platform.",
        ],
      },
    ],
  },
  {
    heading: "5. Free Trial",
    blocks: [
      {
        type: "p",
        text: "Where offered, free trials let you evaluate MagicBolt AI without a credit card. At the end of the trial, continued use requires selecting a paid plan. We may modify or end free trial offers at any time.",
      },
    ],
  },
  {
    heading: "6. White-Label & Reseller Terms",
    blocks: [
      {
        type: "p",
        text: "White-Label and Reseller plan customers may rebrand the platform for their own clients under a custom domain. You remain responsible for your end clients, their data, and compliance with applicable laws in your relationship with them. MagicBolt AI is not a party to agreements between you and your clients.",
      },
    ],
  },
  {
    heading: "7. Acceptable Use",
    blocks: [
      { type: "p", text: "You agree not to:" },
      {
        type: "ul",
        items: [
          "Use the platform for unlawful, fraudulent, spam or abusive purposes.",
          "Attempt to reverse-engineer, resell (outside authorized white-label/reseller plans) or interfere with the platform's operation.",
          "Violate the terms of service of connected third-party platforms (Google, Meta, WordPress, etc.) through your use of MagicBolt AI.",
          "Upload content that infringes intellectual property or violates applicable law.",
        ],
      },
    ],
  },
  {
    heading: "8. Intellectual Property",
    blocks: [
      {
        type: "p",
        text: "The MagicBolt AI platform, branding and underlying technology are the property of MagicBolt Private Limited. Content you create or upload remains yours; you grant us a limited license to process it solely to provide the service.",
      },
    ],
  },
  {
    heading: "9. Third-Party Integrations",
    blocks: [
      {
        type: "p",
        text: "MagicBolt AI integrates with third-party platforms such as Google, Meta (Facebook/Instagram) and WordPress. Your use of these integrations is also subject to each provider's own terms and policies. We are not responsible for outages, policy changes or restrictions imposed by third parties.",
      },
    ],
  },
  {
    heading: "10. Limitation of Liability",
    blocks: [
      {
        type: "p",
        text: "MagicBolt AI is provided \"as is\" without warranties of any kind. To the maximum extent permitted by law, MagicBolt Private Limited shall not be liable for indirect, incidental or consequential damages arising from use of the platform, including loss of data, revenue or business opportunity.",
      },
    ],
  },
  {
    heading: "11. Termination",
    blocks: [
      {
        type: "p",
        text: "You may cancel your subscription at any time from your dashboard. We may suspend or terminate accounts that violate these Terms, engage in abusive behavior, or fail to pay applicable fees.",
      },
    ],
  },
  {
    heading: "12. Governing Law",
    blocks: [
      {
        type: "p",
        text: "These Terms are governed by the laws of India, and any disputes shall be subject to the exclusive jurisdiction of the courts of Bhopal, Madhya Pradesh.",
      },
    ],
  },
  {
    heading: "13. Changes to These Terms",
    blocks: [
      {
        type: "p",
        text: "We may update these Terms from time to time. Continued use of MagicBolt AI after changes take effect constitutes acceptance of the revised Terms.",
      },
    ],
  },
  {
    heading: "14. Contact Us",
    blocks: [
      {
        type: "p",
        text: "Questions about these Terms can be sent to support@magicbolt.ai or MagicBolt Private Limited, Zone-I, Maharana Pratap Nagar, Bhopal, Madhya Pradesh 462012, India.",
      },
    ],
  },
];

export default function TermsPage() {
  return (
    <LegalPageLayout
      testId="terms-page"
      title="Terms & Conditions - MagicBolt AI"
      description="Read the Terms & Conditions governing use of the MagicBolt AI platform, subscriptions, billing and white-label plans."
      path="/terms-conditions"
      eyebrow="Please read carefully"
      heading="Terms & Conditions"
      updated="July 20, 2026"
      sections={SECTIONS}
    />
  );
}
